var version = {
    "name":      "dativery",
    "buildDateCode": "20260409-112855",
    "buildDate": "Thu Apr 09 2026 11:28:55 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260409-112855",
    "backupUIVersion": "2.2.0-20250522-134816"
}
;
 export default version;